import { ModalProps } from '../components/Modal'
import {
  UseFormProps,
  useFormRenderer,
  UseFormReturn,
} from '../contexts/Form.context'

interface CallUseFormProps<T> {
  handler?: (data: T) => Promise<{ ok: boolean }>
  initialValue?: Partial<T>
  modalProps?: Omit<ModalProps, 'children'>
}

export const useForm = <T, K>({
  formComponent,
  extras,
}: UseFormProps<T, K>) => {
  const { formRenderer } = useFormRenderer()

  return async ({
    handler,
    initialValue,
    modalProps,
  }: CallUseFormProps<T>): Promise<UseFormReturn<T>> => {
    try {
      return await formRenderer(
        formComponent,
        handler,
        initialValue,
        extras,
        modalProps
      )
    } catch {
      return { status: 'error' }
    }
  }
}
